import { Box, Button, Dialog, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * DeleteErrorsDialog is a reusable dialog component that prompts the user to confirm the resolution of selected errors.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {boolean} props.open - Controls whether the dialog is open or closed.
 * @param {function} props.onClose - Callback function to close the dialog.
 * @param {function} props.onConfirm - Callback function to handle the confirmation of error resolution.
 * @param {Array<number|string>} props.selectedErrorIds - An array of IDs representing the selected errors.
 */
const DeleteErrorsDialog = ({ open, onClose, onConfirm, selectedErrorIds }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Box m={3}>
        <Typography pt={3} px={3} align="center">
          {selectedErrorIds.length} Errors Selected.
        </Typography>
        <Typography pt={1} pb={2} px={3}>
          Are you sure you want to resolve these errors?
        </Typography>
        <Grid container justifyContent="center" py={3} spacing={3}>
          <Grid>
            <Button onClick={() => onConfirm(selectedErrorIds)} variant="contained" color="primary">
              Yes
            </Button>
          </Grid>
          <Grid>
            <Button onClick={onClose} variant="outlined" color="error">
              No
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};

export default DeleteErrorsDialog;
